/* eslint-disable camelcase */
import * as z from 'zod'

export const schema = z.object({
  accountName: z
    .string({ required_error: 'This field is required' })
    .min(1, { message: 'This field is required' }),
  driver: z
    .string({ required_error: 'This field is required' })
    .min(1, { message: 'This field is required' }),
  email: z
    .string({ required_error: 'This field is required' })
    .min(1, { message: 'This field is required' })
    .max(100, { message: 'Email must be less than 100 characters' })
    .email('Must be a valid email and less than 100 characters'),
  mobile: z
    .string()
    .refine(value => /^\d{9,11}$/.test(value), {
      message: 'Invalid mobile number',
    })
    .optional()
    .or(z.literal('')),
})
